import BaseComponent from "../../../../../lib/components/BaseComponent";

import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";

class DropDownsTest extends BaseComponent {

  render() {

    return <VerticalLayout className='sandbox-container h-full gap-4'>

    </VerticalLayout>

  }

}

export default DropDownsTest;
